module.exports = __webpack_public_path__ + "img/11069850_L.5437a998.png";